import moment from 'moment-jalaali';
import 'moment/locale/en-gb';

const convertJalaliToGregorian = (jalaliDate) => {
  moment.locale('en-gb');
  return moment(jalaliDate, 'jYYYY/jMM/jDD');
};

export default convertJalaliToGregorian;
